import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as faqChatSlice from "../../../../redux/slices/faqChatSlice";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";

const FaqAnswer = () => {
  const [showAddAnswerModal, setShowAddAnswerModal] = useState(false);
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [answerId, setAnswerId] = useState();
  const { allTopics, allSubTopics, allAnswers, loading } = useSelector(
    (state) => state.faqChatSlice
  );

  useEffect(() => {
    if (!showAddAnswerModal) {
      setForm({});
    }
    dispatch(faqChatSlice.getAnswer());
    dispatch(faqChatSlice.getTopics());
    dispatch(faqChatSlice.getSubTopics());
  }, [dispatch]);

  const handleDelete = async (answerId) => {
    await dispatch(faqChatSlice.destroyAnswer(answerId));
    dispatch(faqChatSlice.getAnswer());
    setDeleteModal(false);
  };

  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Sub Topic",
      selector: (row) => row?.sub_topic?.sub_topic || "-",
      sortable: true,
    },
    {
      name: "Answer",
      selector: (row) => row?.answer || "-",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
          <div
            className="edit ml-1"
            onClick={() => {
              handleOnEditClick(row.id);
              setShowAddAnswerModal(true);
              setIsEdit(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = allAnswers?.find((h) => h?.id === id);
    setAnswerId(data?.id);
    setForm({
      ...form,
      topic_id: data?.sub_topic?.topic_id,
      sub_topic_id: data?.sub_topic?.id,
      answer: data?.answer,
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!form?.answer) {
      toast("Please provide an answer before proceeding.");

      return;
    }
    await dispatch(faqChatSlice.updateAnswer(answerId, form, setForm));
    setShowAddAnswerModal(false);
    dispatch(faqChatSlice.getAnswer());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form?.answer) {
      toast("Please provide an answer before proceeding.");

      return;
    }
    await dispatch(faqChatSlice.storeAnswer(form, setForm));
    setShowAddAnswerModal(false);
    dispatch(faqChatSlice.getAnswer());
  };

  console.log(allSubTopics,"topics")
  return (
    <>
      <h5 className="mb-4">FAQ Answers</h5>

      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <Button
            style={{
              backgroundColor: "#e8783d",
              border: "none",
              marginBottom: "1vh",
            }}
            onClick={() => {
              setIsEdit(false);
              setForm({});
              setShowAddAnswerModal(true);
            }}
          >
            Add
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(allAnswers?.length && allAnswers) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      {/* Add Answer Modal */}
      <Modal
        show={showAddAnswerModal}
        onHide={() => setShowAddAnswerModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Update" : "Add"} Answer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formTopic" className="mb-3">
              <Form.Label>Select Topic</Form.Label>
              <Form.Control
                as="select"
                value={form?.topic_id || ""}
                onChange={(e) => setForm({ ...form, topic_id: e.target.value })}
                required
              >
                <option value="" disabled>
                  Select a topic
                </option>
                {allTopics.map((topic) => (
                  // <option key={topic.id} value={topic.id}>
                  //   {topic.topic}
                  // </option>
                   <option key={topic?.id} value={topic?.id} title={topic?.topic}>
                   {topic?.topic?.length > 50 ? `${topic?.topic?.slice(0, 50)}...` : topic?.topic}
                 </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formSubTopic" className="mb-3">
              <Form.Label>Select Sub-Topic</Form.Label>
              <Form.Control
                as="select"
                value={form?.sub_topic_id || ""}
                onChange={(e) =>
                  setForm({ ...form, sub_topic_id: e.target.value })
                }
                required
              >
                <option value="" disabled>
                  Select a subTopic
                </option>
                {allSubTopics
                  .filter((sub) => sub?.topic_id== form?.topic_id)
                  .map((subTopic) => (
                    // <option key={subTopic.id} value={subTopic.id}>
                    //   {subTopic.sub_topic}
                    // </option>

<option key={subTopic?.id} value={subTopic?.id} title={subTopic?.sub_topic}>
{subTopic?.sub_topic?.length > 50 ? `${subTopic?.sub_topic?.slice(0, 50)}...` : subTopic?.sub_topic}
</option>
                  ))}
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formAnswer" className="mb-3">
              <Form.Label>Enter Answer</Form.Label>
              <Form.Control
                type="text"
                value={form?.answer || ""}
                onChange={(e) => setForm({ ...form, answer: e.target.value })}
                placeholder="Enter Answer Here"
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddAnswerModal(false)}
          >
            Close
          </Button>
          {isEdit ? (
            <Button variant="primary" type="submit" onClick={handleUpdate}>
              Update
            </Button>
          ) : (
            <Button variant="primary" type="submit" onClick={handleSubmit}>
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FaqAnswer;
